import { gql } from "@apollo/client";

export const ENABLE_MEMBER_USER = gql`
  mutation EnableMemberUser($id: ID!) {
    enableMemberUser(id: $id)
  }
`;
